

































































































































































import { Component, Prop, PropSync } from 'vue-property-decorator';
import Base from '@/views/Base';
import { PresentationTableItem } from '@/models/Presentation';
import { dateToDateTimeString, getThumbnailUrl } from '@/utils/filters';
import SurveyForm from '@/assets/pictures/survey_form.svg';
import PieChart from '@/assets/pictures/pie_chart.svg';

@Component({
  components: { PieChart, SurveyForm }
})
export default class PresentationTable extends Base {
  @Prop() items!: PresentationTableItem[];
  @Prop() options!: any;
  @PropSync('isSortDesc', { type: Boolean }) isSortDescSync!: boolean;
  @Prop({ type: Boolean }) allSelected!: boolean;
  dateToDateTimeString = dateToDateTimeString;
  getThumbnailUrl = getThumbnailUrl;

  fields = [
    {
      key: 'selected',
      sortable: false,
      thStyle: { width: '35px' },
      class: ' va-middle pl-3 pr-1'
    },
    {
      key: 'number',
      label: 'Nr.',
      sortable: false,
      thStyle: { width: '35px' }
    },
    {
      key: 'thumbnailUrl',
      label: this.t('common.preview'),
      sortable: false,
      thStyle: { width: '70px' }
    },
    {
      key: 'title',
      label: this.t('presentation.title'),
      sortable: true,
      sortDirection: 'asc',
      thStyle: { width: '200px' }
    },
    {
      key: 'dateUpdated',
      label: this.t('presentation.lastModified'),
      sortable: true,
      sortDirection: 'desc',
      thStyle: { width: '170px' }
    },
    {
      key: 'timeToLive',
      label: this.t('presentation.retentionTime'),
      sortable: true,
      thStyle: { width: '150px' }
    },
    {
      key: 'info',
      label: this.t('common.info'),
      sortable: false,
      thStyle: { width: '70px' }
    },
    {
      key: 'elementCount',
      label: this.t('presentation.elements'),
      sortable: true,
      thStyle: { width: '75px' }
    },
    {
      key: 'actions',
      thClass: 'show-content-md',
      thStyle: { width: '85px' }
    }
  ];

  getTTL(item: PresentationTableItem): number {
    const now = new Date();
    const updated = new Date(item.dateUpdated);
    updated.setFullYear(updated.getFullYear() + 1);

    const diff = Math.max(updated.getTime() - now.getTime(), 0);
    // return days to live
    return Math.floor(diff / (1000 * 3600 * 24));
  }

  rowSelected(item: PresentationTableItem, shiftKey: boolean) {
    if (item.isGlobal && !this.hasPermission('CUSTOMER_PRESENTATION')) return;
    this.$emit('row-selected', item, shiftKey);
  }

  handleHeaderClick(isSortable: boolean, event: Event) {
    if (!isSortable) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
